export var renderFilterViewerNumberConditionValue = function renderFilterViewerNumberConditionValue(condition, conditionType, conditionValue) {
  var multiple = condition.multiple;

  var _ref = conditionValue || {},
      value = _ref.value;

  if (multiple) {
    return '';
  }

  if (value === undefined || value === null) {
    return '';
  }

  return value.toString();
};